// extracted by mini-css-extract-plugin
export default {"task-row":"styles_task-row__YuAcm","task-value":"styles_task-value__uH27t","col":"styles_col__x41++","row":"styles_row__Ay2My","time-edit":"styles_time-edit__Y5K7h"};